import {Component, OnInit} from '@angular/core';
import {DataManagementService} from '../services/data-management.service';
import {EpasUtilService} from '../services/epas-util.service';
import {AccessService} from '../services/access.service';
import {Constants} from '../constants';
import * as moment from 'moment-timezone';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import Swal from 'sweetalert2';
import {AppSettings} from '../../app-settings';

@Component({
    selector: 'app-application-form-incoming',
    templateUrl: './application-form-incoming.component.html',
    styleUrls: ['./application-form-incoming.component.css']
})
export class ApplicationFormIncomingComponent implements OnInit {
    downloadStudentDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_INCOMING_STUDENT_DOCUMENT;
    data: object;
    isModifyButtonHidden = true;
    isModifyButtonDisabled = false;
    areInputButtonsDisabled = false;
    isSaveButtonHidden = true;
    activeRoundLink: string;
    activeRound: string;
    route: string;
    timer;
    errorMessage = undefined;
    isDataReady = false;
    withdrawn = false;
    selectUndefinedOptionValue = undefined || null;
    isFinalSubmitted;
    incomingStudentFormData;
    addressFlag = false;
    fileList: FileList;
    country;
    pocDetails;
    presentTerm;
    endTime;
    startTime;
    endTimeStr;
    startTimeStr;
    timeToStart;
    oneSecondTimer;
    currentTime;
    currentTimeStr;
    isRoundEnded = false;
    isRoundExist = false;
    isRoundStarted = false;
    visaAttachment = Constants.VISA_ATTACHMENT;
    mbaTranscriptAttachment = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
    bachelorTranscriptAttachment = Constants.PASSPORT_ATTACHMENT;
    photoAttachment = Constants.PHOTO_ATTACHMENT;
    cvAttachment = Constants.RESUME_ATTACHMENT;
    incomingPassportAttachment = Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT;
    signatureAttachment = Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT;
    incomingStudentId;
    isFlag = true;
    formData: FormData;
    file: File;

    constructor(private accessService: AccessService,
                private utilService: EpasUtilService,
                private dmService: DataManagementService,
                private router: Router,
                private toastr: ToastrService) {
    }

    getFormData(): void {
        this.dmService.javaGetDataCallByParameter(Constants.INCOMING_STUDENT_REGISTRATION, this.incomingStudentId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingStudentFormData = response.data.incoming_student_details;
                        this.country = response.data.country;
                        this.pocDetails = response.data.poc_details;
                        this.isFinalSubmitted = this.incomingStudentFormData.is_final_submitted;
                        this.presentTerm = response.data.present_term;
                        if (this.presentTerm !== null && this.presentTerm !== undefined) {
                            this.endTime = this.presentTerm.registration_end_date;
                            this.startTime = this.presentTerm.registration_start_date;
                            this.endTimeStr = this.getDateTime(this.endTime);
                            this.startTimeStr = this.getDateTime(this.startTime);
                            this.currentTime = (new Date()).getTime();
                            this.timeToStart = moment.duration(this.startTime - this.currentTime);
                            if (this.currentTime < this.endTime) {
                                this.isRoundExist = true;
                            }
                            if (this.currentTime > this.startTime) {
                                this.isRoundStarted = true;
                            }
                            if (this.currentTime > this.endTime) {
                                this.isRoundEnded = true;
                            }
                        }
                        if ( this.isFlag ) {
                            if (this.incomingStudentFormData.incoming_student_id !== 0) {
                                this.isModifyButtonHidden = false;
                                this.areInputButtonsDisabled = true;
                                this.isSaveButtonHidden = true;
                                if (this.incomingStudentFormData.state_name_id === Constants.INCOMING_STUDENT_WITHDRAWN) {
                                    this.withdrawn = true;
                                }
                                if (this.incomingStudentFormData.state_name_id === Constants.INCOMING_STUDENT_ACCEPTED ||
                                    this.incomingStudentFormData.state_name_id === Constants.INCOMING_STUDENT_REJECTED) {
                                    this.isModifyButtonDisabled = true;
                                }
                            } else {
                                this.isModifyButtonHidden = true;
                                this.areInputButtonsDisabled = false;
                                this.isSaveButtonHidden = false;
                            }
                        }
                        this.incomingStudentFormData.dob = this.getDate(this.incomingStudentFormData.dob);
                        this.incomingStudentFormData.passport_issue_date = this.getDate(this.incomingStudentFormData.passport_issue_date);
                        this.incomingStudentFormData.expiry_date = this.getDate(this.incomingStudentFormData.expiry_date);
                        this.incomingStudentFormData.visa_issue_date = this.getDate(this.incomingStudentFormData.visa_issue_date);
                        this.incomingStudentFormData.visa_expiry_date = this.getDate(this.incomingStudentFormData.visa_expiry_date);
                        this.incomingStudentFormData.current_address_valid_till =
                            this.getDate(this.incomingStudentFormData.current_address_valid_till);
                        this.incomingStudentFormData.period_of_study_from =
                            this.getDate(this.incomingStudentFormData.period_of_study_from);
                        this.incomingStudentFormData.period_of_study_to =
                            this.getDate(this.incomingStudentFormData.period_of_study_to);
                        this.incomingStudentFormData.accommodation_from = this.getDate(this.incomingStudentFormData.accommodation_from);
                        this.incomingStudentFormData.accommodation_to = this.getDate(this.incomingStudentFormData.accommodation_to);
                        this.isDataReady = true;
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                });
    }

    getDateTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('YYYY-MM-DD hh:mm:ss A');
    }

    editModal(): void {
        this.areInputButtonsDisabled = false;
        this.isSaveButtonHidden = false;
        this.isModifyButtonHidden = true;
    }

    fileChange(event, documentId) {
        if (event.target.files.length > 1) {
            throw new Error('Cannot upload multiple files on the entry');
        }
        this.fileList = event.target.files;
        const userId = JSON.parse(localStorage.getItem('epas_user')).user_id;
        this.file = event.target.files[0];
        this.formData = new FormData();
        this.formData.append('file', this.file);
        this.formData.append('incoming_student_id', this.incomingStudentFormData.incoming_student_id);
        this.formData.append('document_type_id', documentId);
        this.formData.append('user_id', userId);
    }

    uploadDocument() {
        if ( this.formData === undefined || this.formData === null ) {
            this.toastr.warning('Please select the file and .', 'Required');
            return;
        }
        this.dmService.javaUploadIncomingStudentDocument(this.formData).subscribe(response => {
            if (response.status === 'success') {
                this.formData = undefined;
                this.toastr.success('Successfully uploaded the file ' + this.file.name, 'Success');
                this.isFlag = false;
                this.getFormData();
            } else if (response.status === 'fail') {
                if (response.hasOwnProperty('message')) {
                    this.toastr.warning(response.message, 'Fail');
                } else {
                    this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                }
            }
        }, error => {
            console.log(error);
            this.toastr.warning('Something went wrong. please contact support team', 'Fail');
        });
    }

    deleteDocument(documentId) {
        const finalData = {
            incoming_student_id: this.incomingStudentFormData.incoming_student_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        if (documentId === Constants.VISA_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.visa_attachment_id;
            finalData['document_type_id'] = Constants.VISA_ATTACHMENT;
        } else if (documentId === Constants.LATEST_TRANSCRIPT_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.latest_transcript_attachment_id;
            finalData['document_type_id'] = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
        } else if (documentId === Constants.PASSPORT_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.passport_attachment_id;
            finalData['document_type_id'] = Constants.PASSPORT_ATTACHMENT;
        } else if (documentId === Constants.PHOTO_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.photo_attachment_id;
            finalData['document_type_id'] = Constants.PHOTO_ATTACHMENT;
        }  else if (documentId === Constants.RESUME_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.resume_attachment_id;
            finalData['document_type_id'] = Constants.RESUME_ATTACHMENT;
        } else if (documentId === Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.hostel_coc_attachment_id;
            finalData['document_type_id'] = Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT;
        } else if (documentId === Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.release_cum_identity_bond_attachment_id;
            finalData['document_type_id'] = Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT;
        } else if (documentId === Constants.HEALTH_CERTIFICATE_ATTACHMENT) {
            finalData['document_id'] = this.incomingStudentFormData.health_certificate_attachment_id;
            finalData['document_type_id'] = Constants.HEALTH_CERTIFICATE_ATTACHMENT;
        }
        this.dmService.javaPostDataCall(finalData, Constants.INCOMING_STUDENT_FILE_DELETE).subscribe(response => {
            if (response.status === 'success') {
                this.toastr.success('Successfully deleted the file ', 'Success');
                this.isFlag = false;
                this.getFormData();
            } else if (response.status === 'fail') {
                if (response.hasOwnProperty('message')) {
                    this.toastr.warning(response.message, 'Fail');
                } else {
                    this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                }
            }
        }, error => {
            console.log(error);
            this.toastr.warning('Something went wrong. please contact support team', 'Fail');
        });
    }

    uploadIncomingStudentDetails(): void {
        this.isFlag = true;
        this.incomingStudentFormData.is_final_submitted = false;
        if (this.incomingStudentFormData.incoming_student_id === 0) {
            this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
        }
        if (this.addressFlag === true) {
            this.incomingStudentFormData.permanent_address_line1 = this.incomingStudentFormData.current_address_line1;
            this.incomingStudentFormData.permanent_address_line2 = this.incomingStudentFormData.current_address_line2;
            this.incomingStudentFormData.permanent_city = this.incomingStudentFormData.current_city;
            this.incomingStudentFormData.permanent_country_id = this.incomingStudentFormData.current_country_id;
            this.incomingStudentFormData.permanent_zipcode = this.incomingStudentFormData.current_zipcode;
        }
        this.incomingStudentFormData['user_id'] = JSON.parse(localStorage.getItem('epas_user')).user_id;
        this.dmService.javaPostDataCall(this.incomingStudentFormData, Constants.INCOMING_STUDENT_REGISTRATION)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.toastr.success('Successfully updated the registration form.', 'Success');
                        this.getFormData();
                    } else if (response.status === 'fail') {
                        this.toastr.warning(response.message, 'Fail');
                    }
                },
                error => {
                    console.log(error);
                    this.toastr.error('Server Error', 'Error');
                });
    }

    finalSubmitRegistrationForm(e): void {
        this.isFlag = true;
        e.preventDefault();
        this.incomingStudentFormData.is_final_submitted = true;
        if (this.incomingStudentFormData.incoming_student_id === 0) {
            this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
        }
        if (this.addressFlag === true) {
            this.incomingStudentFormData.permanent_address_line1 = this.incomingStudentFormData.current_address_line1;
            this.incomingStudentFormData.permanent_address_line2 = this.incomingStudentFormData.current_address_line2;
            this.incomingStudentFormData.permanent_city = this.incomingStudentFormData.current_city;
            this.incomingStudentFormData.permanent_country_id = this.incomingStudentFormData.current_country_id;
            this.incomingStudentFormData.permanent_zipcode = this.incomingStudentFormData.current_zipcode;
        }
        this.incomingStudentFormData['user_id'] = JSON.parse(localStorage.getItem('epas_user')).user_id;
        const that = this;
        let uploadResponse;
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'You can not modify your details once the registration is submitted.' +
                ' Are you sure you want to continue?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(that.incomingStudentFormData, Constants.FINAL_INCOMING_STUDENT_REGISTRATION)
                        .subscribe(data => {
                            uploadResponse = data;
                            resolve(uploadResponse);
                        }, error => {
                            uploadResponse = error;
                            reject(uploadResponse);
                        });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (uploadResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
                        that.router.navigate(['application-incoming']));
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: uploadResponse.message,
                        });
                    } else {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: '<p>Successfully submitted registration.</p>',
                        });
                    }
                } else if (uploadResponse.status === 'fail') {
                    if (uploadResponse.hasOwnProperty('message')) {
                        Swal({type: 'error', title: 'Fail', html: uploadResponse.message});
                    } else {
                        Swal({type: 'error', title: 'Fail', text: 'Unable to upload registration form, Please contact support team.'});
                    }
                }
            }
        });
    }

    getDate(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).tz('Asia/Kolkata').format('YYYY-MM-DD');
    }

    sameAsCurrentAddress(): void {
        this.addressFlag = !this.addressFlag;
    }

    ngOnInit() {
        this.route = this.router.url;
        console.log(this.route);
        this.incomingStudentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.incoming_student_id;
        this.getFormData();
        this.oneSecondTimer = setInterval(() => {
            if (this.isDataReady === true) {
                this.currentTime = (new Date()).getTime();
                this.currentTime = moment(this.currentTime).utcOffset('+05:30').add({'seconds': 1});
                this.currentTimeStr = this.currentTime.format('DD-MMM-YYYY, hh:mm:ss A');
                if (this.currentTime < this.startTime) {
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                }
            }
            if (this.route.indexOf('/application-incoming') === -1) {
                clearInterval(this.oneSecondTimer);
            }
        }, 1000);
    }

}
